import { createMetaManager } from "vue-meta";
import { plugin as vueMetaPlugin } from 'vue-meta'

export default {
  install: (app) => {
    app.use(createMetaManager());
    app.use(vueMetaPlugin);
  },
};
